import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTalentMutation, useUpdateTalent } from "../../actions/authActions";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
export default () => {
  const userData = useSelector((state) => state.app.userData.userData);
  const {
    data: talentData,
    // isLoading,
    isError,
    error,
  } = useUpdateTalent(userData?.talent?.id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [videos, setVideos] = useState([{ title: "", link: "", image: null }]);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    trigger,
    watch,
    unregister,
  } = useForm({
    defaultValues: {
      videos: [{ title: "", link: "", image: null }],
    },
  });

  const mutation = useTalentMutation(
    talentData?.id,
    dispatch,
    setLoadingToapi,
    navigate
  );
  const handleAddVideos = () => {
    const newIndex = videos.length;
    setVideos([...videos, { title: "", link: "", image: null }]);
    setValue(`videos.${newIndex}.title`, "");
    setValue(`videos.${newIndex}.link`, "");
  };
  const handleRemoveVideos = (indexToRemove) => {
    const fields = watch(`videos`);
    // Remove videos from local state
    const updatedVideos = [...fields];
    updatedVideos.splice(indexToRemove, 1);
    setVideos(updatedVideos);
    unregister("videos");

    // Reset values for all remaining videos, including file input
    updatedVideos.forEach((proj, idx) => {
      setValue(`videos.${idx}.title`, proj.title);
      setValue(`videos.${idx}.link`, proj.link);
      setValue(`videos.${idx}.image`, proj.image ?? null);
    });

    // Optionally re-run validation on videos after update
    trigger("videos");
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);
    const apiData = new FormData();
    apiData.append("stage_name", talentData?.stage_name);
    apiData.append("age", talentData?.age);
    apiData.append("gender", talentData?.gender?.gender_id);
    apiData.append("_method", "PUT");
    data.videos.forEach((video, i) => {
      apiData.append(`video_title[${i}]`, video.title || "");
      apiData.append(`video_external_url[${i}]`, video.link || "");
      if (videos[i]?.image) {
        apiData.append(`video_image[${i}]`, videos[i].image);
      }
    });

    // Submit the form
    mutation.mutate(apiData);
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading Videos: {error.message}</p>
      </div>
    );
  }
  return {
    handleSubmit,
    onSubmit,
    register,
    errors,
    videos,
    handleAddVideos,
    handleRemoveVideos,
    control,
    loadingToapi,
    setVideos,
    setValue,
  };
};
